/* Cosmic theme — theme.js (vanilla, no dependencies) */
(function () {
  'use strict';

  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const T = window.theme || { routes: {}, strings: {} };

  /* ---------- Money formatting ---------- */
  function formatMoney(cents, format) {
    format = format || T.moneyFormat || '${{amount}}';
    if (typeof cents === 'string') cents = cents.replace('.', '');
    const placeholder = /\{\{\s*(\w+)\s*\}\}/;
    const match = format.match(placeholder);
    const type = match ? match[1] : 'amount';
    function fmt(number, precision, thousands, decimal) {
      thousands = thousands || ','; decimal = decimal || '.';
      if (isNaN(number) || number == null) return '0';
      number = (number / 100).toFixed(precision);
      const parts = number.split('.');
      const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return dollars + (parts[1] ? decimal + parts[1] : '');
    }
    let value = '';
    switch (type) {
      case 'amount': value = fmt(cents, 2); break;
      case 'amount_no_decimals': value = fmt(cents, 0); break;
      case 'amount_with_comma_separator': value = fmt(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = fmt(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = fmt(cents, 2, "'", '.'); break;
      default: value = fmt(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  window.theme.formatMoney = formatMoney;

  /* ---------- Toast ---------- */
  let toastTimer;
  function toast(msg, isError) {
    const el = $('[data-toast]');
    if (!el) return;
    el.textContent = msg;
    el.classList.toggle('toast--error', !!isError);
    el.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => el.classList.remove('is-visible'), 2800);
  }

  /* ---------- Overlay & drawers ---------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  let lastFocus = null;

  function trapFocus(container) {
    const focusables = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', container);
    if (!focusables.length) return;
    const first = focusables[0], last = focusables[focusables.length - 1];
    container._trap = function (e) {
      if (e.key !== 'Tab') return;
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    };
    container.addEventListener('keydown', container._trap);
    setTimeout(() => (first.focus()), 50);
  }

  function open(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return;
    if (openDrawer && openDrawer !== drawer) close(false);
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    drawer.removeAttribute('inert');
    overlay && overlay.classList.add('is-active');
    document.body.classList.add('overflow-hidden');
    openDrawer = drawer;
    trapFocus(drawer);
    $$('[aria-controls="' + id + '"]').forEach(b => b.setAttribute('aria-expanded', 'true'));
  }
  function close(restore = true) {
    if (!openDrawer) return;
    const d = openDrawer;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    d.setAttribute('inert', '');
    if (d._trap) d.removeEventListener('keydown', d._trap);
    overlay && overlay.classList.remove('is-active');
    document.body.classList.remove('overflow-hidden');
    $$('[aria-controls="' + d.id + '"]').forEach(b => b.setAttribute('aria-expanded', 'false'));
    openDrawer = null;
    if (restore && lastFocus) lastFocus.focus();
  }
  window.theme.openDrawer = open;
  window.theme.closeDrawer = close;
  // Drawer menus ship as text templates (see header.liquid) so crawlers count each nav link once; build them here.
  $$('[data-drawer-template]').forEach(el => {
    const tpl = document.getElementById(el.getAttribute('data-drawer-template'));
    if (tpl) el.innerHTML = tpl.textContent;
  });

  document.addEventListener('click', e => {
    const opener = e.target.closest('[data-drawer-open]');
    if (opener) { e.preventDefault(); open(opener.getAttribute('data-drawer-open')); return; }
    if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); close(); return; }
  });
  overlay && overlay.addEventListener('click', () => { close(); closeSearch(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') { close(); closeSearch(); closeSubmenus(); } });

  /* ---------- Header ---------- */
  const headerWrap = $('[data-header-wrapper]');
  if (headerWrap) {
    const onScroll = () => headerWrap.classList.toggle('is-scrolled', window.scrollY > 10);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Desktop submenus (click + hover)
  function closeSubmenus(except) {
    $$('.header__nav-item.is-open').forEach(i => { if (i !== except) { i.classList.remove('is-open'); const b = $('[aria-expanded]', i); b && b.setAttribute('aria-expanded', 'false'); } });
  }
  $$('.header__nav-item[data-has-children]').forEach(item => {
    const btn = $('.header__nav-link', item);
    btn.addEventListener('click', e => {
      e.preventDefault();
      const isOpen = item.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', isOpen);
      closeSubmenus(item);
    });
    item.addEventListener('mouseenter', () => { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('mouseleave', () => { item.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); });
  });
  document.addEventListener('click', e => { if (!e.target.closest('.header__nav-item')) closeSubmenus(); });

  /* ---------- Search bar ---------- */
  const searchBar = $('[data-search-bar]');
  function openSearch() {
    if (!searchBar) return;
    searchBar.classList.add('is-open');
    $$('[data-search-toggle]').forEach(b => b.setAttribute('aria-expanded', 'true'));
    const input = $('input[type="search"]', searchBar);
    input && setTimeout(() => input.focus(), 40);
  }
  function closeSearch() {
    if (!searchBar || !searchBar.classList.contains('is-open')) return;
    searchBar.classList.remove('is-open');
    $$('[data-search-toggle]').forEach(b => b.setAttribute('aria-expanded', 'false'));
  }
  $$('[data-search-toggle]').forEach(b => b.addEventListener('click', e => { e.preventDefault(); searchBar.classList.contains('is-open') ? closeSearch() : openSearch(); }));
  $$('[data-search-close]').forEach(b => b.addEventListener('click', closeSearch));

  // Predictive search (lightweight)
  if (searchBar && T.routes.predictiveSearch) {
    const input = $('input[type="search"]', searchBar);
    const results = $('[data-search-results]', searchBar);
    let timer, controller;
    input && results && input.addEventListener('input', () => {
      clearTimeout(timer);
      const q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; results.classList.remove('has-results'); return; }
      timer = setTimeout(async () => {
        try {
          controller && controller.abort();
          controller = new AbortController();
          const url = T.routes.predictiveSearch + '?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
          const res = await fetch(url, { signal: controller.signal, headers: { Accept: 'application/json' } });
          const data = await res.json();
          const products = (data.resources && data.resources.results && data.resources.results.products) || [];
          if (!products.length) { results.innerHTML = ''; results.classList.remove('has-results'); return; }
          results.innerHTML = '<div class="search-bar__results-grid">' + products.map(p => {
            const img = p.featured_image && p.featured_image.url ? '<img src="' + p.featured_image.url + '&width=88" alt="" loading="lazy">' : '';
            return '<a href="' + p.url + '">' + img + '<span>' + cleanTitle(p.title) + '<br><small>' + formatMoney(Math.round(parseFloat(p.price) * 100)) + '</small></span></a>';
          }).join('') + '</div>';
          results.classList.add('has-results');
        } catch (err) { /* aborted or failed; ignore */ }
      }, 220);
    });
  }
  function cleanTitle(t) {
    if (!window.theme.cleanTitles) return t;
    let s = t.split('|')[0].trim().replace(/^3d printed\s+/i, '');
    return s || t;
  }

  /* ---------- Announcement rotation ---------- */
  $$('[data-announcement]').forEach(bar => {
    const slides = $$('.announcement__slide', bar);
    if (slides.length < 2) return;
    let i = 0;
    const delay = parseInt(bar.dataset.interval || '5000', 10);
    setInterval(() => { slides[i].classList.remove('is-active'); i = (i + 1) % slides.length; slides[i].classList.add('is-active'); }, delay);
  });

  /* ---------- Quantity steppers (delegated) ---------- */
  document.addEventListener('click', e => {
    const btn = e.target.closest('[data-quantity-minus], [data-quantity-plus]');
    if (!btn) return;
    const wrap = btn.closest('[data-quantity]');
    const input = $('[data-quantity-input]', wrap);
    if (!input) return;
    const min = parseInt(input.min || '0', 10);
    const max = input.max ? parseInt(input.max, 10) : Infinity;
    let v = parseInt(input.value || '0', 10);
    v = btn.hasAttribute('data-quantity-plus') ? v + 1 : v - 1;
    v = Math.min(Math.max(v, min), max);
    input.value = v;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  const Cart = {
    async add(formData) {
      formData.append('sections', 'cart-drawer,cart-icon-bubble');
      formData.append('sections_url', window.location.pathname);
      const res = await fetch(T.routes.cartAdd + '.js', { method: 'POST', body: formData, headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || T.strings.error);
      this.renderSections(data.sections);
      return data;
    },
    async change(payload) {
      payload.sections = 'cart-drawer,cart-icon-bubble,main-cart';
      payload.sections_url = window.location.pathname;
      const res = await fetch(T.routes.cartChange + '.js', { method: 'POST', body: JSON.stringify(payload), headers: { 'Content-Type': 'application/json', Accept: 'application/json' } });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || T.strings.error);
      this.renderSections(data.sections);
      return data;
    },
    renderSections(sections) {
      if (!sections) return;
      Object.keys(sections).forEach(id => {
        const html = sections[id];
        if (!html) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        if (id === 'cart-icon-bubble') {
          const fresh = $('[data-cart-count]', doc);
          $$('[data-cart-count]').forEach(el => { if (fresh) { el.textContent = fresh.textContent; el.dataset.count = fresh.dataset.count; el.classList.remove('is-bumping'); void el.offsetWidth; el.classList.add('is-bumping'); } });
          return;
        }
        const target = document.getElementById('shopify-section-' + id) || $('[data-section-id="' + id + '"]');
        const fresh = $('#shopify-section-' + id, doc) || doc.body.firstElementChild;
        if (target && fresh) {
          // Preserve open state for the drawer
          const wasOpen = target.querySelector('.drawer.is-open');
          target.innerHTML = fresh.innerHTML;
          if (wasOpen) { const d = target.querySelector('.drawer'); if (d) { d.classList.add('is-open'); d.setAttribute('aria-hidden', 'false'); d.removeAttribute('inert'); openDrawer = d; } }
        }
      });
    }
  };
  window.theme.cart = Cart;

  function setLoading(btn, on) {
    if (!btn) return;
    btn.classList.toggle('is-loading', on);
    btn.disabled = on;
  }

  // Product forms and quick add (delegated)
  document.addEventListener('submit', async e => {
    const form = e.target;
    if (!form.matches('[data-product-form], [data-quick-add-form]')) return;
    e.preventDefault();
    const btn = $('[type="submit"]', form);
    setLoading(btn, true);
    try {
      const fd = new FormData(form);
      await Cart.add(fd);
      if (T.cartType === 'drawer' && document.getElementById('CartDrawer')) {
        open('CartDrawer');
      } else if (T.cartType === 'page') {
        window.location.href = T.routes.cart;
        return;
      } else {
        toast(T.strings.added);
      }
      document.dispatchEvent(new CustomEvent('cart:added'));
    } catch (err) {
      toast(err.message || T.strings.error, true);
    } finally {
      setLoading(btn, false);
    }
  });

  // Cart line changes (drawer + page)
  let changeTimer;
  document.addEventListener('change', e => {
    const input = e.target.closest('[data-line-quantity]');
    if (!input) return;
    const item = input.closest('[data-cart-item]');
    clearTimeout(changeTimer);
    changeTimer = setTimeout(async () => {
      item.classList.add('is-loading');
      try { await Cart.change({ id: item.dataset.key, quantity: parseInt(input.value, 10) }); }
      catch (err) { toast(err.message, true); item.classList.remove('is-loading'); }
    }, 300);
  });
  document.addEventListener('click', async e => {
    const btn = e.target.closest('[data-cart-remove]');
    if (!btn) return;
    e.preventDefault();
    const item = btn.closest('[data-cart-item]');
    item.classList.add('is-loading');
    try { await Cart.change({ id: item.dataset.key, quantity: 0 }); }
    catch (err) { toast(err.message, true); item.classList.remove('is-loading'); }
  });

  // Cart note
  let noteTimer;
  document.addEventListener('input', e => {
    const note = e.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(() => {
      fetch(T.routes.cartUpdate + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ note: note.value }) });
    }, 500);
  });

  /* ---------- Product page ---------- */
  class ProductForm {
    constructor(root) {
      this.root = root;
      this.form = $('[data-product-form]', root);
      const dataEl = $('[data-product-json]', root);
      if (!this.form || !dataEl) return;
      this.product = JSON.parse(dataEl.textContent);
      this.idInput = $('input[name="id"]', this.form);
      this.optionInputs = $$('[data-option-index]', root);
      this.priceEl = $('[data-product-price] .price', root) || $('[data-product-price]', root) || $('.product__info .price', root);
      this.button = $('[data-add-button]', this.form);
      this.buttonText = $('.btn__text', this.button);
      this.skuEl = $('[data-product-sku]', root);
      this.inventoryEl = $('[data-inventory]', root);
      this.gallery = new Gallery($('[data-gallery]', root));
      this.optionInputs.forEach(i => i.addEventListener('change', () => this.onChange()));
      this.updateAvailability();
    }
    currentOptions() {
      const opts = [];
      $$('[data-option-index]', this.root).forEach(el => {
        const idx = parseInt(el.dataset.optionIndex, 10);
        if (el.tagName === 'SELECT') opts[idx] = el.value;
        else if (el.checked) opts[idx] = el.value;
      });
      return opts;
    }
    findVariant(opts) {
      return this.product.variants.find(v => v.options.every((o, i) => o === opts[i]));
    }
    onChange() {
      const opts = this.currentOptions();
      const variant = this.findVariant(opts);
      this.updateAvailability();
      if (!variant) { this.setButton(false, T.strings.unavailable); return; }
      this.idInput.value = variant.id;
      // Selected value labels ("Size: Large")
      $$('[data-option-index]', this.root).forEach(el => {
        if (el.tagName === 'SELECT' || !el.checked) return;
        const fs = el.closest('fieldset');
        const lbl = fs && fs.querySelector('[data-selected-value]');
        if (lbl) lbl.textContent = el.value;
      });
      // URL
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variant.id);
      window.history.replaceState({}, '', url);
      // Price
      if (this.priceEl) {
        const cur = $('[data-price-current]', this.priceEl), cmp = $('[data-price-compare]', this.priceEl);
        cur && (cur.textContent = formatMoney(variant.price));
        if (cmp) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) { cmp.textContent = formatMoney(variant.compare_at_price); cmp.hidden = false; this.priceEl.classList.add('price--on-sale'); }
          else { cmp.hidden = true; this.priceEl.classList.remove('price--on-sale'); }
        }
      }
      if (this.skuEl) this.skuEl.textContent = variant.sku || '';
      this.setButton(variant.available, variant.available ? T.strings.addToCart : T.strings.soldOut);
      if (variant.featured_media && this.gallery) this.gallery.show(variant.featured_media.id);
      // sticky bar price
      const sp = $('[data-sticky-price]'); sp && (sp.textContent = formatMoney(variant.price));
      // Inventory
      if (this.inventoryEl) {
        const inv = this.inventoryEl.dataset;
        const qtyEl = this.root.querySelector('[data-variant-inventory="' + variant.id + '"]');
        if (qtyEl) { this.inventoryEl.innerHTML = qtyEl.innerHTML; this.inventoryEl.className = qtyEl.className.replace('hidden', '').trim(); this.inventoryEl.hidden = !qtyEl.innerHTML.trim(); }
      }
      document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant } }));
    }
    setButton(enabled, text) {
      if (!this.button) return;
      this.button.disabled = !enabled;
      if (this.buttonText) this.buttonText.textContent = text;
      const dyn = $('[data-dynamic-checkout]', this.root);
      dyn && dyn.classList.toggle('hidden', !enabled);
    }
    updateAvailability() {
      // Mark option values that lead to no available variant given other selections
      const opts = this.currentOptions();
      $$('[data-option-index]', this.root).forEach(el => {
        if (el.tagName === 'SELECT') return;
        const idx = parseInt(el.dataset.optionIndex, 10);
        const test = opts.slice(); test[idx] = el.value;
        const v = this.product.variants.find(x => x.options.every((o, i) => i === idx ? o === el.value : (opts[i] == null || o === opts[i])));
        el.classList.toggle('is-unavailable', !v || !v.available);
      });
    }
  }

  class Gallery {
    constructor(root) {
      if (!root) return;
      this.root = root;
      this.items = $$('.media-item', root);
      this.thumbs = $$('[data-thumb]', root);
      this.thumbs.forEach(t => t.addEventListener('click', () => this.show(t.dataset.thumb)));
      // Swipe on main image
      const main = $('.product__main-image', root);
      let x0 = null;
      main && main.addEventListener('touchstart', e => { x0 = e.touches[0].clientX; }, { passive: true });
      main && main.addEventListener('touchend', e => {
        if (x0 == null) return;
        const dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 40) this.step(dx < 0 ? 1 : -1);
        x0 = null;
      });
    }
    show(id) {
      let found = false;
      this.items.forEach(i => { const on = i.dataset.mediaId == id; i.classList.toggle('is-active', on); if (on) found = true; if (!on) { const v = i.querySelector('video'); v && v.pause(); } });
      if (!found) return;
      this.thumbs.forEach(t => { const on = t.dataset.thumb == id; t.classList.toggle('is-active', on); if (on) t.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' }); });
    }
    step(dir) {
      const idx = this.items.findIndex(i => i.classList.contains('is-active'));
      const next = (idx + dir + this.items.length) % this.items.length;
      this.show(this.items[next].dataset.mediaId);
    }
  }

  $$('[data-product]').forEach(el => new ProductForm(el));

  // Sticky add-to-cart bar
  const sticky = $('[data-sticky-atc]');
  const mainBtn = $('[data-product] [data-add-button]');
  if (sticky && mainBtn && 'IntersectionObserver' in window) {
    new IntersectionObserver(entries => {
      const show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', show);
      // Lift the Shopify chat button above the bar so it never covers Add to cart
      document.documentElement.style.setProperty('--sticky-atc-h', sticky.offsetHeight + 'px');
      document.documentElement.classList.toggle('has-sticky-atc', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (show) sticky.removeAttribute('inert'); else sticky.setAttribute('inert', '');
    }, { threshold: 0 }).observe(mainBtn);
    const stickyBtn = $('[data-sticky-submit]', sticky);
    stickyBtn && stickyBtn.addEventListener('click', () => { const f = $('[data-product] [data-product-form]'); f && f.requestSubmit(); });
  }

  /* ---------- Facets (collection filters) ---------- */
  $$('[data-facets-form]').forEach(form => {
    let t;
    form.addEventListener('change', () => { clearTimeout(t); t = setTimeout(() => form.requestSubmit(), 150); });
    form.addEventListener('submit', e => {
      // strip empty inputs so URLs stay clean
      $$('input, select', form).forEach(i => { if (!i.value && i.type !== 'checkbox') i.disabled = true; });
    });
  });
  $$('[data-sort-select]').forEach(sel => sel.addEventListener('change', () => {
    const url = new URL(window.location.href);
    url.searchParams.set('sort_by', sel.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  }));

  /* ---------- Address forms (account) ---------- */
  document.addEventListener('click', e => {
    const t = e.target.closest('[data-address-toggle]');
    if (!t) return;
    const target = document.getElementById(t.getAttribute('data-address-toggle'));
    target && target.classList.toggle('is-open');
  });
  document.addEventListener('click', e => {
    const d = e.target.closest('[data-address-delete]');
    if (!d) return;
    if (!window.confirm(d.dataset.confirm || 'Delete this address?')) return;
    const form = document.createElement('form');
    form.method = 'post'; form.action = d.dataset.target;
    form.innerHTML = '<input type="hidden" name="_method" value="delete">';
    document.body.appendChild(form); form.submit();
  });

  /* Scroll reveal disabled: content is always visible. */
  $$('.scroll-reveal').forEach(el => el.classList.add('is-visible'));

  /* ---------- Theme editor hooks ---------- */
  document.addEventListener('shopify:section:load', e => {
    $$('[data-product]', e.target).forEach(el => new ProductForm(el));
    $$('.scroll-reveal', e.target).forEach(el => el.classList.add('is-visible'));
  });
  document.addEventListener('shopify:section:select', e => {
    const drawer = e.target.querySelector('.drawer');
    if (drawer) open(drawer.id);
  });
  document.addEventListener('shopify:section:deselect', e => { if (e.target.querySelector('.drawer')) close(); });
})();
